<template>
  <v-layout column>
    <v-layout>
      <top-info-panel>
        <v-flex xs12 md12 lg6 xl6 px-2 pb-3 slot="content">
          <v-layout row>
            <v-btn color="accent" fab class="btn-edit-asset mr-4" @click="editMode = true" v-show="!editMode"> <v-icon>edit</v-icon></v-btn>
            <v-btn color="accent" fab class="btn-edit-asset mr-4" @click="editMode = false" v-show="editMode"> <v-icon class="fas fa-undo"></v-icon></v-btn>
            <v-flex xs10 justify-center style="z-index:1000;">
              <h4>Dossier voor POI: {{geoZone.name}}</h4>Het dossier voor uw point of interest bevat zowel de actuele status alsmede de historische data (indien aanwezig). Assets aanwezig op locatie en andere data kunnen hier worden ingezien.
            </v-flex>
            <v-flex class="topbar-icon">
              <i :class="` primary--text text--lighten-2`"></i>
              <!-- <font-awesome-icon icon="gas-pump" class="asset-icon" /> -->
            </v-flex>
          </v-layout>          
        </v-flex>        
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">
<!-------------- EDIT POI SCREEN ----------------------------------------------------------------------------------------------------------->      
      <v-flex xs12 md12 lg8 xl6 pt-2 v-if="editMode">
        <v-widget>      
          <v-layout slot="widget-content" >
             <v-layout row wrap>
                <v-layout column>            
                  <v-form
                      ref="geoZoneForm"
                      v-model="formValid"
                      lazy-validation>                            
                      <v-flex>
                          <v-flex sm12> 
                              <v-text-field
                                  label="Naam voor Point of interest"
                                  hint="Omschrijving voor uw point of interest"                                
                                  :rules="[formRules.name]"   
                                  v-model="name"
                                  required
                              ></v-text-field>
                          </v-flex>
                          <v-flex>                            
                              <v-select 
                              item-value="id"
                              item-text="name"                                 
                              :items="geoZoneTypes"
                              label="Type point of interest"
                              :rules="[formRules.type]"                                   
                              v-model="geoZoneTypeId"
                              required
                              ></v-select>    
                          </v-flex>                                
                          <v-flex>
                              <v-textarea
                                  name="input-7-1"
                                  label="Omschrijving"
                                  value=""
                                  v-model="description"
                                  hint="Optionele omschrijving en/of opmerkingen voor uw poi"
                                  ></v-textarea>
                          </v-flex>                      
                      </v-flex>                                                                    
                  </v-form>                     
                  <custom-fields 
                      :customFields="customFieldsOnGeoZone" 
                      v-model="selectedCustomFields" 
                  >
                  </custom-fields>        
                  <v-flex class="py-2" d-flex>
                    <v-btn  @click="editMode=false">Annuleren</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="success" @click="saveGeoZone()">Opslaan</v-btn>
                  </v-flex>                      
                </v-layout>            
        <!---------- ADD IMAGE ------------------------------------------------------------------------------------------>                   
                <v-layout column >
                    <v-flex sm12 lg6 grey lighten-4 d-flex class="file-upload-holder px-2 ml-3 py-3" >                                                                                        
                        <v-flex v-if="!geoZoneImage">
                            <strong>Afbeelding</strong><br><br>
                            <file-upload 
                                class="px-2"
                                :url="imageUploadUrl" 
                                @isUploading="imageUploading"
                                @uploadDone="imageUploadingDone"
                                :blockUI="true"
                            ></file-upload>
                        </v-flex>
                        <v-flex v-else d-flex class="px-2 py-3">
                                <v-flex d-flex>
                                    <img :src="imageUrl" class="dd-uploaded-image" style='height: 100%; width: 100%; object-fit: contain'>
                                </v-flex>
                                
                                <div class="btn-image-delete">
                                    <v-btn color="accent" fab @click="deleteMainImage()">                                
                                        <v-icon class="fas fa-trash"></v-icon>
                                    </v-btn>
                                </div>                        
                        </v-flex>                    
                    </v-flex>                  
                </v-layout>                                          
             </v-layout>         
          </v-layout>    
        </v-widget>
      </v-flex>
      <v-flex xs12 md12 lg12 xl12 pt-2 v-if="!editMode">
        <v-widget :enableHeader="true">      
          <v-layout slot="widget-header-action">                      
              <v-spacer></v-spacer>
              <v-flex justify-end style="display: flex;">
                <v-btn flat small :color="(showTarget == 'overview') ? 'accent' : 'primary'" @click="view('overview') ">Overzicht</v-btn>
                <v-btn flat small color="primary" @click="editMode = true">Configuratie</v-btn>
              </v-flex>
          </v-layout>
          <v-layout slot="widget-content" v-show="showTarget == 'overview'" >
            <v-layout row wrap slot="content" px-1 py-1>
              <v-flex lg7 d-flex>
                <v-layout column>
                  <v-flex>
                    <v-layout row>
                      <v-flex lg6 d-flex px-2 py-2>
                        <v-card color="primary" class="white--text">
                          <v-layout>
                            <v-flex xs8>
                              <v-card-title primary-title>
                                <div>
                                  <div class="headline">{{geoZone.name}}</div>
                                  <div> Type: <i>{{geoZoneTypeName}}</i></div>                                  
                                  <div> Actief: <i>{{geoZoneActive}}</i></div>
                                  <div> POI Oppervlakte: <i>{{geoJsonSquareMeasureHumanReadable(geoZone.squareMeters)}}</i> </div>
                                  <div> POI Omtrek: <i>{{geojsonLineDistanceHumanReadable(geoZone.perimeterMeters)}}</i></div>
                                </div>
                              </v-card-title>
                            </v-flex>   
                            <v-flex xs4 align-center d-flex class="text-xs-right">
                              <i class="fas fa-map-marker-alt fa-8x card-watermark"></i>                              
                            </v-flex>                                                  
                          </v-layout>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 md8 lg6 style d-flex px-2 py-2>
                        <v-card color="white">
                          <v-layout column style="height: 200px;" justify-center align-center>
                              <h4>Assets aanwezig op locatie </h4>                                                                                      
                              <label style="font-size:80px; font-weight:bold;" class="accent--text">{{assetsWithinGeoZone.length}}</label>                              
                            </v-card-text>                            
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md12 lg12 d-flex>
                    <v-layout >
                      <v-flex xs12 md12 lg6 d-flex px-2 py-2>
                        <v-card color="orange lighten-2" dark v-show="showMap">
                          <l-map
                            :zoom="zoom"
                            :options="mapOptions"
                            :bounds="bounds"
                            style="min-height:300px;"
                          >
                            <l-group >
                                <l-polygon 
                                    :color="zoneColor(geoZoneTypeId)"
                                    :fillColor="zoneColor(geoZoneTypeId)"
                                    :lat-lngs="zoneCoordinates(geoZone)"                               
                                >
                                </l-polygon>
                            </l-group>   
                            <l-group v-if="markersForLocations.length > 0"> 
                              <l-marker
                                v-for="marker of markersForLocations"
                                
                                :latLng="[marker.lat, marker.lon]"
                                :key="marker.positionIndex"
                                :icon="assetPositionIcon(marker)"
                              >
                              </l-marker>
                            </l-group>

                            <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>
                            <l-control-zoom position="topright"></l-control-zoom>
                          </l-map>
                          <!-- <v-card-text>i</v-card-text> -->
                        </v-card>
                      </v-flex>
                      <v-flex xs12 md12 lg6 d-flex align-start>
                        <v-layout column  >
                          <v-flex xs12 md12 lg6 px-2 py-2 d-flex>
                            <v-card  class="py-4 grey lighten-3" v-if="!geoZone.customFieldValues" style="display: flex; justify-content: center; align-content:center; align-items:center;flex-direction:column;">                              
                              <div><i class="fas fa-info-circle grey--text text--lighten-2 fa-4x"></i></div>
                              <div><h4 class="grey--text text--lighten-2">Geen extra velden geconfigureerd</h4></div>
                            </v-card>
                            <v-card v-else class="grey lighten-3">
                              <v-layout row wrap px-4 py-2>
                                <v-flex sm12 lg12 xl6 v-for="cf in geoZone.customFieldValues" :key="cf.name">
                                    <div class="dd-label">{{cf.name}}</div>
                                    <div class="dd-value">{{cf.value}}</div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex px-2 py-2 > 
                            <v-card v-if="!imageUrl" color="secondary" style="min-height:180px; display: flex; justify-content: center; align-content:center; align-items:center;flex-direction:column;">                              
                              <div><i class="fas fa-camera white--text fa-4x"></i></div>
                              <div><h4 class="white--text ">Geen foto ingesteld</h4></div>
                            </v-card>
                            <v-card v-else> 
                              <v-img :src="imageUrl" contain>
                              </v-img>
                              <!-- <img :src="imageUrl" class="dd-uploaded-image" style='height: 100%; width: 100%; object-fit: contain'>   -->
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- hier stonden events achter kaart -->
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex lg5 align-baseline>
                <v-layout row>
                  <v-flex lg12 d-flex px-2 py-2>
                    <v-card lg12>
                      <v-tabs v-model="selectedTab" grow>
                        <v-tab key="assets_on_location" >Aanwezig op locatie</v-tab>
                        <v-tab key="events">Events</v-tab>
                        <v-tab key="history" >Geschiedenis</v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="selectedTab">
        <!-------------- ASSET ON LOCATION TAB ---------------------------->
                        <v-tab-item key="assets_on_location">
                          <v-card flat>
                            <v-card-text style="padding: 0px 0px;">
                              <v-data-table
                                :headers="assetHeader"
                                :items="assetsWithinGeoZone"
                                hide-actions
                                class="elevation-0 table-striped"
                                style="border-top: 1px #ccc solid"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr v-on:mouseover="highlightedPositionMarker=props.item.id" v-on:mouseout="highlightedPositionMarker=null">
                                      <td>
                                        <dd-tool-tip :text="props.item.group.name">
                                          <i :class="props.item.group.icon"> </i>
                                        </dd-tool-tip>                                        
                                      </td>                                      
                                      <td>{{props.item.name}}</td>                                      
                                      <td>{{props.item.type.name}}</td>
                                      <td>{{since(props.item.unitIdentifier)}}</td>
                                      <td @click="routeToAsset(props.item)">     
                                       
                                            <v-icon style="cursor:pointer;" small >open_in_new</v-icon>                                                                                   
                                       
                                      </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
          <!------------ EVENTS TAB ---------------------------->
                        <v-tab-item key="events">
                          <v-card flat>
                            <v-card-text>
                              <template v-if="showAssetsInGeozoneGrid">
                                <v-data-table
                                  :hide-headers="true"
                                  :items="eventsWithinGeoZone"
                                  hide-actions
                                  class="elevation-0 table-striped"
                                  style="border-top: 1px #ccc solid"
                                >
                                  <template slot="items" slot-scope="event">
                                    <tr style="cursor: pointer;" @click="infoEventClicked(event.item)">
                                      <td class="color-table-bar" :style="` border-left-color: ${color(event.item.messageType)}; `"></td>                                                          
                                      <td style="width:20px;"> <i :class="event.item.dossier.asset.group.icon"></i> </td>                            
                                      <td> {{event.item.dossier.asset.name}} </td>                                      
                                      <td class="text-xs-left pl-0">{{ event.item.messageType}}</td>
                                      <td class="text-xs-left">{{ event.item.timestamp | time }}</td>
                                      <td class="text-xs-left" style="min-w">{{ event.item.timestamp | date_nl }}</td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </template>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
              <!-------- HISTORY TAB ---------------------------->
                        <v-tab-item key="history">                            
                          <v-card flat>
                            <v-card-text>
                              <template>
                                <v-data-table
                                  :hide-headers="true"
                                  :items="geoZoneProcessedEvents"
                                  hide-actions
                                  class="elevation-0 table-striped"
                                  style="border-top: 1px #ccc solid"
                                > 
                                  <template slot="items" slot-scope="geoEvent">
                                    <tr style="cursor: pointer;" @click="infoEventClicked(geoEvent.item)">
                                      <td class="color-table-bar" :style="` border-left-color: ${color(geoEvent.item.messageType)}; `"></td>                                      
                                      <td style="width:20px;"> <i :class="geoEvent.item.dossier.asset.group.icon"></i> </td>                                      
                                      <td> {{geoEvent.item.dossier.asset.name}} </td>                                                                            
                                      <td class="text-xs-left pl-0">{{ geoEvent.item.title }}</td>
                                      <td class="text-xs-left">{{ geoEvent.item.timestamp | time }}</td>
                                      <td class="text-xs-left" style="min-w">{{ geoEvent.item.timestamp | date_nl }}</td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </template>
                            </v-card-text>
                          </v-card>                   
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-widget>
      </v-flex>
    </v-layout>

  </v-layout>
</template>
<script>
import Vue2Leaflet from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";
import { API_URL, MAP_URL, IMAGE_URL } from "../../config.js";
import moment from "moment";
import * as types from "../../store/types";
import { timeDifference } from "../../plugins/core/dd.time";
import VWidget from "../../components/global/VWidget";
import TimeSerieLine from "../../components/graph/TimeSerieLine";
import GraphCircularCard from "../../components/graph/GraphCircularCard"
import GraphIconLabelCard from "../../components/graph/GraphIconLabelCard"
import TopInfoPanel from "../../components/global/TopInfoPanel";
import MapMixin from '../../plugins/mixins/MapMixin'
import ColorMixin from "../../plugins/mixins/ColorMixin.js";
import polyLineUtil from "@mapbox/polyline";
import ColorHash from 'color-hash'; 
import CustomFields from "../../components/form/CustomFields"
import DdToolTip from "../../components/global/DdTooltip"
import FileUpload from '../../components/form/FileUpload'
import _ from 'lodash';

export default {
  components: {
    FileUpload,
    DdToolTip,
    TopInfoPanel,
    VWidget,
    GraphCircularCard,
    GraphIconLabelCard,    
    CustomFields,
    "l-map": Vue2Leaflet.LMap,
    "l-tilelayer": Vue2Leaflet.LTileLayer,
    "l-marker": Vue2Leaflet.LMarker,
    "l-group": Vue2Leaflet.LLayerGroup,
    "l-popup": Vue2Leaflet.LPopup,
    "l-polyline": Vue2Leaflet.LPolyline,
    "l-tooltip": Vue2Leaflet.LTooltip,
    "l-control-zoom": Vue2Leaflet.LControlZoom
  },
  mixins: [ColorMixin,MapMixin],
  data() {
    return {
      showAssetsInGeozoneGrid:false,
      assetHeader:[
          { text: "", sortable: false },
          { text: "Asset", sortable: false },
          { text: "Type", sortable: false },
          { text: "Tijd aanwezig", sortable: false },
          { text: "", sortable: false }          
      ],
      refreshCalls:false,
      formValid:true,
      formRules:{
          name:(value) => {return (value) ? true : "Veld verplicht"},
          type:(value) => {return (value) ? true : "Veld verplicht"}
      },      
      id:null,
      name:"",
      geoZoneTypeId:null,
      geoZoneImage:null,
      description:"",
      assetLocationsMap: {
        bounds: [52,6],
        center: [52,6],
        zoom: 11
      },
      selectedTab: 0,
      zoom: 11,
      url: MAP_URL, //'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [
      ],
      bounds: null,
      mapOptions: { zoomControl: false },
      showMap: true,
      showRoute: false,
      editMode: false,
      showTarget: 'overview',
      locationsFrom: null,
      locationsTill: null,
      showFromDatePicker: false,
      showTillDatePicker: false,
      highlightedPositionMarker: null,
      selectedCustomFields:{}
    };
  },
  computed: {
    ...mapGetters({        
        geoZone:types.GEO_ZONE,
        geoZoneTypes: types.GEO_ZONE_TYPES,       
        geoZoneCustomFields: types.GEO_ZONE_CUSTOM_FIELDS,    
        eventsWithinGeoZone: types.EVENTS_WITHIN_GEO_ZONE,    
        assetsWithinGeoZone: types.ASSETS_WITHIN_GEO_ZONE,     
        geoZoneProcessedEvents: types.GEO_ZONE_PROCESSED_EVENTS,
        assetsInGeoZoneSince: types.ASSETS_IN_GEO_ZONE_SINCE
    }), 
    imageUploadUrl(){
        return `${ API_URL}/geo-zones/${this.geoZone.id}/main-image`
    },    
    markersForLocations(){
      let arr = []
      for(let asset of this.assetsWithinGeoZone){          
          let item = {}
          item.lat = asset.lat
          item.lon = asset.lon
          item.name = asset.name 
          item.icon = asset.group ? asset.group.icon : ""
          item.color = (asset.id == this.highlightedPositionMarker) ? this.primaryColor : this.accentColor
          arr.push(item)            
      }
      return arr
    },
    geoZoneTypeName(){
      return this.geoZone && this.geoZone.geoZoneType ? this.geoZone.geoZoneType.name : ""
    },    
    customFieldsOnGeoZone(){
        let custom = []
        this.geoZoneCustomFields.forEach((field) => {
            custom.push(field.customField)
        })
        return custom
    },    
    geoZoneActive(){
      return this.geoZone.active ? "Ja" : "Nee"
    },
// ----------------------------------------------- old --------------------------------------------------------------
    positionsByDay(){                          
      let arr = []
       
      return arr
    },
    markersForLocationsBounds(){
      let arr = []
      return arr
    },
    imageUrl(){
      if(!this.geoZone.mainImage)
        return null

      return `${IMAGE_URL}/${this.geoZone.mainImage.publicLocation}`;
    },
    selectedRouteStart() {
      return L.latLng(
        this.showRoute.fromAddress.lat,
        this.showRoute.fromAddress.lon
      );
    },
    selectedRouteEnd() {
      return L.latLng(
        this.showRoute.toAddress.lat,
        this.showRoute.toAddress.lon
      );
    },
    selectedRoutePolygon() {
      return polyLineUtil.decode(this.showRoute.geometry, 6);
    },
    hasPosition() {
      return false;
    },
  
    defaultTimeSerie() {
      let res =  null
      return res;
    },
    processedEventTableHeaders() {
      return [
        {
          text: "",
          // value: string
          align: "center",
          sortable: false,
          // class: string[] | string
          width: "38px"
        },

        {
          text: "Omschrijving",
          align: "left",
          sortable: false
        },
        {
          text: "Tijd",
          align: "left",
          sortable: false
        },
        {
          text: "Datum",
          align: "left",
          sortable: false,
          width: "150px"
        }
      ];
    }

  },
  methods: {
    since(identifier){
        let item = this.assetsInGeoZoneSince.filter((ele) => {
          return ele.unit_identifier == identifier 
        })

        // found identifier
        if(item[0]){
          return this.$options.filters.timeAgoShort(item[0].timestamp)
        }
        return "Onbekend";
    },        
    infoEventClicked(event){
    },
    imageUploading(e){
        console.log("uploading...", e)
    },
    imageUploadingDone(res){
        this.geoZoneImage = res;
        console.log("uploading done!")
    },    
    routeToAsset(asset){
      this.$router.push({ path: `/asset-details/${asset.id}` })
    },
    centerGeozone(zone){
        this.bounds = this.zoneCoordinates(zone)
    },    
    zoneCoordinates(zone){
        if(!zone.geopoly || !zone.geopoly.coordinates)
          return []

        return this.geojsonCoordinatesToPoly(zone.geopoly.coordinates)
    },    
    discardable(event) {
      if (event.unitTypeEvent.eventType.internalName == "error") {
        if (event.unitTypeEvent.eventSeverity.id >= 3) {
          return true;
        }
      }
      if (event.unitTypeEvent.eventType.internalName == "warning") {
        if (event.unitTypeEvent.eventSeverity.id >= 5) {
          return true;
        }
      }
    },    
    view(target){      
      this.showTarget = target;
    },
    zoneColor(zoneTypeId){
        let colorHash = new ColorHash({hue: {min: 220, max: 270}});                
        return colorHash.hex(zoneTypeId);    
    },  
    assetPositionIcon(assetPositionObj){

      let html = `<div class="marker-pin">
                    <div
                      class="inner-pin "
                      style="background-color:${assetPositionObj.color}">
                      <i class="${assetPositionObj.icon}"></i>
                    </div>  
                  </div>`;

      return L.divIcon({
        iconSize: new L.Point(34, 34),
        iconAnchor: [17, 34],
        someData: "test",
        html
      });
    },
    streetTypeClass(street){
      if(street){
        if(street[0] == 'A' && (parseInt(street[1]) > 0)){
          return 'road-a-type'
        }
        if(street[0] == 'E' && (parseInt(street[1]) > 0)){
          return 'road-e-type'
        }
        if(street[0] == 'N' && (parseInt(street[1]) > 0)){
          return 'road-n-type'
        }
        else{
          return 'road-urban-type'
        }
      }
      return '';
    },
    graphValue(data){      
      if(data.dataType == 'numeric' && data.decimals > 0){
        parseFloat(data.value).toFixed(data.decimals)
      }
      return (data.value)
    },
    showRouteToMap(route) {
      this.showRoute = route;
      this.bounds = polyLineUtil.decode(route.geometry, 6);
    },

    actionStatusColor(action) {
      if (action.status.internalName == "open") {
        return this.infoColor;
      }
      if (action.status.internalName == "done") {
        return this.successColor;
      }
      if (action.status.internalName == "cancelled") {
        return this.errorColor;
      }
    },

    colorForEventType(internalName) {
      switch (internalName) {
        case "info":
          return "blue";
        case "warning":
          return "amber";
        case "error":
          return "red";
        case "success":
          return "green";
      }
    },
    colorForEventSeverity(internalName) {
      switch (internalName) {
        case "irrelevant":
          return "#E0E0E0";
        case "low":
          return "#2196F3";
        case "average":
          return "#FF9800";
        case "high":
          return "#F44336";
        case "critical":
          return "#F44336";
      }
    },
    saveGeoZone(){
        if (this.$refs.geoZoneForm.validate()) {                    
            this.$store.dispatch(types.SAVE_GEO_ZONE, {data: { id:this.id , name: this.name, description: this.description, geo_zone_type_id:this.geoZoneTypeId ,geojson: this.geoJSON }}).then((res) => {

                let obj = _.pickBy(this.selectedCustomFields, (ele) => ele != undefined)
                this.$store.dispatch(types.SAVE_GEO_ZONE_CUSTOM_FIELD_VALUES, {data: { geoZoneId: this.geoZone.id, fields: obj } }).then( () => {
                    this.$notify('Point of interest aangepast', {type: 'success', icon: 'check'})   
                    this.editMode=false
                })
            })
        }      
    },
    loadGeoZoneTypes(){
        if(this.geoZoneTypes.length==0){
                this.$store.dispatch(types.GEO_ZONE_TYPES,{})
        }
    },    
    loadGeoZoneCustomFields(){
        this.$store.dispatch(types.GEO_ZONE_CUSTOM_FIELDS,{params:{include:"customField,customField.type"}}).then(() => {})
    },
    loadAssetsWithinGeoZone(){                    
        let vm = this
        this.$store.dispatch(types.ASSETS_WITHIN_GEO_ZONE,{data:{id:vm.$route.params.geoZoneId},params:{include:"group,type"}}).then(() => {        
            if(vm.refreshCalls){
              console.log(vm.assetsWithinGeoZone)
              // reload each minute    
              setTimeout( ()=>{ vm.loadAssetsWithinGeoZone()},60000)                              
            }
        })         
    },    
    loadEventsWithinGeoZone(){
      if(this.refreshCalls){
        let vm = this
        this.$store.dispatch(types.EVENTS_WITHIN_GEO_ZONE,{data:{id:vm.$route.params.geoZoneId},params:{include:"itemType,dossier.asset.group,user"}}).then(() => {        
          if(vm.refreshCalls){
            // reload each minute    
            setTimeout( ()=>{ vm.loadEventsWithinGeoZone()},60000)                              
          }
        })
      }        
    },
    loadGeoZoneProcessedEvents(){                    
        let vm = this
        this.$store.dispatch(types.GEO_ZONE_PROCESSED_EVENTS,{data:{id:vm.$route.params.geoZoneId},params:{include:"itemType,dossier.asset.group,user"}}).then(() => {        
          
          console.log("geozone processed events: ",this.geoZoneProcessedEvents);

           if(vm.refreshCalls){
              // reload each minute    
              setTimeout( ()=>{ vm.loadGeoZoneProcessedEvents()},60000)                              
            }
        })        
    },       
    loadAssetsInGeoZoneSince(){                    
        let vm = this
        this.$store.dispatch(types.ASSETS_IN_GEO_ZONE_SINCE,{data:{geoZoneId:vm.$route.params.geoZoneId},params:{}}).then(() => {     
          
           this.showAssetsInGeozoneGrid=true;
           if(vm.refreshCalls){
              // reload each minute    
              setTimeout( ()=>{ vm.loadAssetsInGeoZoneSince()},60000)                              
            }
        })
    },
  },
  mounted() {
    this.$store.dispatch(types.FS_LOADING, true);

    this.refreshCalls=true
    this.loadAssetsWithinGeoZone()
    this.loadEventsWithinGeoZone()
    this.loadGeoZoneProcessedEvents()
    this.loadAssetsInGeoZoneSince()

    this.loadPoiEvents
    this.loadGeoZoneTypes()
    this.loadGeoZoneCustomFields()

    this.locationsFrom = moment().subtract(3, 'months').format('YYYY-MM-DD');
    this.locationsTill = moment().format('YYYY-MM-DD');

    let p1 = this.$store.dispatch(types.GEO_ZONE, 
      {data:{id:this.$route.params.geoZoneId},
       params:{include:`geoZoneType,mainImage`}
      }).then(()=>{
          this.centerGeozone(this.geoZone);

          if(this.geoZone){
              this.id            = this.geoZone.id
              this.name          = this.geoZone.name            
              this.description   = this.geoZone.description
              this.geoZoneTypeId = this.geoZone.geoZoneType.id

              if(this.geoZone.mainImage){
                this.geoZoneImage = this.geoZone.mainImage
              }

              if(this.geoZone.customFieldValues){
                this.geoZone.customFieldValues.forEach((field) => {
                    this.selectedCustomFields[field.name] = field.value
                })
              }     
          }          
          this.$store.dispatch(types.FS_LOADING, false);
      })

    this.$store.dispatch(types.BACKGROUND_ICON, "globe-europe");
  },
  beforeDestroy() {
    this.refreshCalls = false
    this.$store.dispatch(types.BACKGROUND_ICON, null);
  }
};
</script>
<style >
.circle-dot {
  width: 16px;
  height: 16px;
  position: absolute;
  display: inline-block;
  border-radius: 100%;
  line-height: 1.7;
  padding: 0;
  margin-top: 20px;
  margin-left: -8px;
  border-color: rgba(255, 255, 255, 0.8);
  border-width: 2px;
  border-style: solid;
}

.marker-pin {
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 40px 40px 14px 40px;
  position: relative;
  -webkit-transform: rotate(45deg);
  box-shadow: -2px 2px 6px -1px rgba(0, 0, 0, 0.7) !important;
}

.inner-pin > .material-icons {
  font-size: 16px !important;
}
.inner-pin {
  -webkit-transform: rotate(-45deg);
  position: absolute;
  background-color: red;

  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin-top: 2px;
  margin-left: 2px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-weight: bold;
  font-stretch: normal;

  line-height: 47px;
  font-family: Helvetica, Arial, sans-serif;
  text-shadow: 1px 1px rgba(0, 0, 0, 0.01), 2px 2px rgba(0, 0, 0, 0.13),
    3px 3px rgba(0, 0, 0, 0.125), 4px 4px rgba(0, 0, 0, 0.02),
    5px 5px rgba(0, 0, 0, 0.015), 6px 6px rgba(0, 0, 0, 0.01),
    7px 6px rgba(0, 0, 0, 0.01), 8px 8px rgba(0, 0, 0, 0.01),
    9px 8px rgba(0, 0, 0, 0.01), 10px 10px rgba(0, 0, 0, 0.01),
    11px 11px rgba(0, 0, 0, 0.01), 12px 12px rgba(0, 0, 0, 0.01),
    13px 13px rgba(0, 0, 0, 0.01), 14px 14px rgba(0, 0, 0, 0.01),
    15px 15px rgba(0, 0, 0, 0.01), 16px 16px rgba(0, 0, 0, 0.01),
    17px 17px rgba(0, 0, 0, 0.01), 18px 18px rgba(0, 0, 0, 0.01),
    19px 19px rgba(0, 0, 0, 0.01), 20px 20px rgba(0, 0, 0, 0.01),
    21px 21px rgba(0, 0, 0, 0.01), 22px 22px rgba(0, 0, 0, 0.01),
    23px 23px rgba(0, 0, 0, 0.01);
  overflow: hidden;
}

@keyframes flickerAnimation {
  /* flame pulses */
  0% {
    opacity: 1;
  }
  /* 20%  { opacity:0.6; } */
  40% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

.ignition-on-pin {
  opacity: 1;
  animation: flickerAnimation 1.7s infinite;
}
.ignition-off-pin {
  opacity: 0.4;
}

.leaflet-div-icon {
  background: none !important;
  border: none !important;
}

.card-watermark {
  opacity: 0.2;
  margin-right: 14px;
}

.color-table-bar {
  border-left-color: #eee;
  border-left-width: 4px;
  border-left-style: solid;
  width:2px !important;
  padding:0px !important;
  
}

.map-toggle {
  flex: 0 !important;
  position: absolute;
  z-index: 1000;
}

.topbar-icon {
  font-size: 100px;
  position: absolute;
  right: 0;
  display: flex;
  margin-top: -20px !important;
  margin-right: 30px;
}

.route-badge-container {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  color: #fff;
}

.route-badge {
  width: 70px;
  padding: 4px 6px;
  text-align: center;
  font-weight: 700;
  border-radius: 4px;
}

.btn-edit-asset{
  z-index:1000;
  position: absolute;
  
}

.dd-asset-map{
  height: calc(100vh - 320px);
  
}

.road-a-type{
  background-color: #f44336;
  color: #fff;
  padding: 2px 4px;
  border-radius: 5px;
}

.road-e-type{
  background-color: green;
  color: #fff;
  padding: 2px 4px;
  border-radius: 5px;
}

.road-n-type{
  background-color: #F4DD0D;
  color: #000;
  padding: 2px 4px;
  border-radius: 5px;
}

.road-urban-type{
  background-color: #0194e0;
  color: #fff;
  padding: 2px 8px;
  border-radius: 5px;
}

.day-header{
  background-color: #eee;
  
}
.day-header td{
  padding: 6px 8px;
  font-weight: 600;
}
.location-row td{
  padding: 1px 0px;
}

.location-row:hover{
  background-color: #eee;
}

.marker-number{
  display: flex;
  justify-content: center;
  width: 28px;
  color: #fff;
  background-color: #777;
}

.highlighted-position-row{
  background-color: #f9bd6d !important;
}

.locations-textual{
  flex: 0;
  
  overflow-y: scroll !important;
  height: calc(100vh - 420px);
  min-height: 400px;
  
}
</style>
